import getMinBuyForQuantityDropdown from "./AddToCart/getMinBuyForQuantityDropdown";

interface Props {
  minimumBuy: number;
  mustBuy: number;
  price: number;
}
export default ({ minimumBuy, mustBuy, price }: Props): number => {
  if (minimumBuy > 1 || mustBuy > 1) {
    const updatedMinBuy = getMinBuyForQuantityDropdown({
      minBuy: minimumBuy,
      mustBuy,
    });

    return price * Math.max(updatedMinBuy, mustBuy);
  }

  return price;
};
